import React, { useState } from "react";
import materialsData from "./hooks/materialsData";
import AreaSelection from "./components/AreaSelection";
import AreaDetails from "./components/AreaDetails";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Button from "react-bootstrap/Button";

function App() {
  const [selectedArea, setSelectedArea] = useState(null);
  const { materials, loading } = materialsData();

  return (
    <div className="App">
      {!selectedArea ? (
        <AreaSelection
          materials={materials}
          setSelectedArea={setSelectedArea}
        />
      ) : (
        <>
          {selectedArea && (
            <AreaDetails
              selectedArea={selectedArea}
              materials={materials}
            />
          )}
          <Button
            style={{
              marginBottom: "100px",
              padding: "20px",
              backgroundColor: "#d6e0db",
              color: "#0f6c65",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            onClick={() => setSelectedArea(null)}
          >
            Terug naar selectie
          </Button>
        </>
      )}
    </div>
  );
}

export default App;
